import { axiosInstance } from '@/modules/shared/lib/axios'
import { CompanyGroupDto } from './types'

type Props = {
  companyId: string
}

export function getCompanyGroups({ companyId }: Props) {
  return axiosInstance.get<CompanyGroupDto[]>(
    `/config-api/${companyId}/configuration/admin/companies/groups`
  )
}
